<section class="bg-eggshell">
  <div class="about-section container py-5">
    <div class="row align-items-center">
      <!-- Text Content -->
      <div class="col-lg-6 px-md-5 px-4">
        <p class="section-subtitle m-0">“Since 2017”</p>
        <h1 class="section-title">India’s Leading Pure Veg Hotel Chain</h1>

        <p class="section-body">
          Our Chain of Hotels is situated amidst everything that is
          quintessential to the Himalayan threshold.
        </p>

        <p class="section-body">
          You will find yourself surrounded by a unique variety of sightseeing
          destinations, splendid views, eccentric antiquity stores, and a
          multitude of tea plantations. These exquisite facets blend to
          perfection to make your stay a wholesome experience of a lifetime.
          Udaan Hotels & Resorts has some of the best pure veg hotels and
          resorts in Darjeeling, Gangtok, Lachung, Pelling, Kalimpong, and
          Siliguri.
        </p>

        <div class="d-flex align-items-center mt-4">
          <div>
            <h6 class="mb-0 team-udaan-text">- Team Udaan</h6>
          </div>
        </div>
      </div>

      <!-- Image Content -->
      <div class="col-lg-6 px-md-5 px-4 text-center position-relative">
        <div class="about-image-wrapper d-inline-block">
          <img
            src="/assets/images/Grains.jpg"
            alt="Hotel Room"
            class="img-fluid shadow"
            height="600"
            width="900"
          />
        </div>
      </div>
    </div>
  </div>
</section>
